import React, { useState, useEffect } from "react";
import { Container, TextField, Divider, Card, Button, Typography, Grid, CardActions, LinearProgress, InputAdornment, Switch } from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { useSelector, useDispatch } from 'react-redux'
import { privateDBCreate } from 'api/privatedb';
import { v4 as uuidv4 } from 'uuid'
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import FieldLayout from "components/elements/field-layout";
import CTxtFld from 'components/elements/text-field'
import { usePrivateDBEditMutation, usePrivateDBDetailsQuery, usePrivateDBDeleteMutation } from "services/privatedb";

const PrivateDBEdit = (props) => {
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const navi = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const privateDB = useSelector(state => state.privateDB.create);
    const [disableButton, setDisableButton] = useState(false);
    const [validEmail, setValidEmail] = useState(false);
    const [invalidEmail, setInValidEmail] = useState(false);
    const [emailStatus, setEmailStatus] = useState('');
    const [privateDBEditMutation, { isLoading: isUpdating }] = usePrivateDBEditMutation();
    const [pDBDelete, { isLoading: isDeleting }] = usePrivateDBDeleteMutation();


    const handleCancel = () => {
        navi("/privatedb/list")
    }

    const handleDelete = () => {
        pDBDelete({ id: id })
            .unwrap()
            .then(result => {
                setTimeout(() => {
                    setDisableButton(false);
                    navi("/privatedb/list");
                }, 5000)
            })
            .catch(err => {
                setTimeout(() => {
                    setDisableButton(false);
                    navi("/privatedb/list");
                }, 5000)
            })


    }

    const { privateDBDetails, privateDBStatus, privateDBLoading, fetching } = usePrivateDBDetailsQuery({ id: id },
        {
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                privateDBDetails: data || {},
                privateDBStatus: status,
                privateDBLoading: isLoading,
                fetching: isFetching
            })
        }
    );

    useEffect(() => {
        if (privateDBDetails.id) {
            console.log(privateDBDetails)
            dispatch(privateDBCreate(privateDBDetails));
            setValidEmail(true)
        }
    }, [privateDBDetails])

    const onStatusChange = (event) => {
        dispatch(privateDBCreate({ status: event.target.checked }))
    }

    const onSave = () => {
        var record = {
            "doc": {
                ...privateDB
            }

        }
        if (validEmail && emailStatus === '') {
            setDisableButton(true);
            privateDBEditMutation(record)
                .unwrap()
                .then(result => {
                    setTimeout(() => {
                        setDisableButton(false);
                        navi("/privatedb/list");
                    }, 5000)
                })
                .catch(err => {
                    setTimeout(() => {
                        setDisableButton(false);
                        navi("/privatedb/list");
                    }, 5000)
                })
        }
    }

    return (
        <React.Fragment>
            <CommonListHeader value={{ title: `Edit PrivateDB: ${privateDBDetails.case_name}`, description: "You are editing PrivateDB details." }} />
            <Container maxWidth={'md'}>
                <Card>
                    {disableButton ? <LinearProgress /> : ''}
                    <Container maxWidth={false} sx={{ paddingTop: "10px" }}>
                        <FieldLayout {...{ title: 'Case Name' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ case_name: event.target.value }))} value={privateDB.case_name || ''} /></FieldLayout>

                        <FieldLayout {...{ title: 'VIN' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ vin: event.target.value }))} value={privateDB.vin || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Vehicle Year' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ car_year: event.target.value }))} value={privateDB.car_year || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Vehicle Make' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ car_make: event.target.value }))} value={privateDB.car_make || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Vehicle Model' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ car_model: event.target.value }))} value={privateDB.car_model || ''} /></FieldLayout>

                        <FieldLayout {...{ title: 'Tire Brand/Type' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ brand: event.target.value }))} value={privateDB.brand || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'P/LT/Eur-Metric' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ metric: event.target.value }))} value={privateDB.metric || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Section Width' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ section_width: event.target.value }))} value={privateDB.section_width || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Aspect Ratio' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ aspect_ratio: event.target.value }))} value={privateDB.aspect_ratio || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Rim Diameter' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ rim_diameter: event.target.value }))} value={privateDB.rim_diameter || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Plant Code' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ plant_code: event.target.value }))} value={privateDB.plant_code || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Size Code' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ size_code: event.target.value }))} value={privateDB.size_code || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Aux Info.' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ aux_info: event.target.value }))} value={privateDB.aux_info || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Cure Week/Year' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ cure_wkyr: event.target.value }))} value={privateDB.cure_wkyr || ''} /></FieldLayout>

                        <FieldLayout {...{ title: 'DOT Number' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ dot: event.target.value }))} value={privateDB.dot || ''} /></FieldLayout>

                        <FieldLayout {...{ title: 'Speed Rating' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ speed_rating: event.target.value }))} value={privateDB.speed_rating || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Load Range' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ load_range: event.target.value }))} value={privateDB.load_range || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Construction' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ construction: event.target.value }))} value={privateDB.construction || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Punctures/Repairs' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ repairs: event.target.value }))} value={privateDB.repairs || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Min. Tread Depth (32nds of in.)' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ min_tread_depth: event.target.value }))} value={privateDB.min_tread_depth || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Max. Tread Depth (32nds of in.)' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ max_tread_depth: event.target.value }))} value={privateDB.max_tread_depth || ''} /></FieldLayout>
                        <FieldLayout {...{ title: 'Failure Mode' }}><CTxtFld onChange={(event) => dispatch(privateDBCreate({ failure_mode: event.target.value }))} value={privateDB.failure_mode || ''} /></FieldLayout>

                        {/* <FieldLayout {...{title:'Failure Factors'}}><CTxtFld onChange={(event)=>dispatch(privateDBCreate({failure_factors: event.target.value}))} value={privateDB.failure_factors || ''}  /></FieldLayout> */}


                        <Divider sx={{ marginY: "10px" }} />

                        <Grid container item md={12} display="flex" justifyContent="space-between">
                            <Grid container item md={6} display="flex" direction="column">
                                <Typography variant="h6">Failure Factors</Typography>
                            </Grid>
                        </Grid>

                        <Divider sx={{ marginY: "10px" }} />

                        <FieldLayout {...{ title: 'Manufacture Defect' }}>
                            <Switch checked={privateDB?.mfg_defect} onChange={(event) => dispatch(privateDBCreate({ mfg_defect: event.target.checked }))} />
                        </FieldLayout>
                        <FieldLayout {...{ title: 'Design Defect' }}>
                            <Switch checked={privateDB?.design_defect} onChange={(event) => dispatch(privateDBCreate({ design_defect: event.target.checked }))} />
                        </FieldLayout>
                        <FieldLayout {...{ title: 'Aging' }}>
                            <Switch checked={privateDB?.aging} onChange={(event) => dispatch(privateDBCreate({ aging: event.target.checked }))} />
                        </FieldLayout>
                        <Divider sx={{ marginY: "10px" }} />

                        <Grid container item md={12} display="flex" justifyContent="space-between">
                            <Grid container item md={6} display="flex" direction="column">
                                <Typography variant="h6">TSA+ Alerts</Typography>
                            </Grid>
                        </Grid>

                        <Divider sx={{ marginY: "10px" }} />



                        <FieldLayout {...{ title: 'Defective Tire Alert' }}>
                            <Switch checked={privateDB?.defective_tire_alert} onChange={(event) => dispatch(privateDBCreate({ defective_tire_alert: event.target.checked }))} />
                        </FieldLayout>
                        <FieldLayout {...{ title: 'Early Warning Alert' }}>
                            <Switch checked={privateDB?.early_warning_alert} onChange={(event) => dispatch(privateDBCreate({ early_warning_alert: event.target.checked }))} />
                        </FieldLayout>
                        <FieldLayout {...{ title: 'Early Degradation Alert' }}>
                            <Switch checked={privateDB?.early_degradation_alert} onChange={(event) => dispatch(privateDBCreate({ early_degradation_alert: event.target.checked }))} />
                        </FieldLayout>
                        <FieldLayout {...{ title: 'Forensic Investigation Alert' }}>
                            <Switch checked={privateDB?.forensic_investigation_alert} onChange={(event) => dispatch(privateDBCreate({ forensic_investigation_alert: event.target.checked }))} />
                        </FieldLayout>

                        <FieldLayout {...{ title: 'Reported Tire Failure Alert' }}>
                            <Switch checked={privateDB?.reported_tire_failure_alert} onChange={(event) => dispatch(privateDBCreate({ reported_tire_failure_alert: event.target.checked }))} />
                        </FieldLayout>
                        <FieldLayout {...{ title: 'Dealer Reported Tire Failure Alert' }}>
                            <Switch checked={privateDB?.dealer_reported_tire_failure_alert} onChange={(event) => dispatch(privateDBCreate({ dealer_reported_tire_failure_alert: event.target.checked }))} />
                        </FieldLayout>
                        <FieldLayout {...{ title: 'Reported Early Warning Alert' }}>
                            <Switch checked={privateDB?.reported_early_waring_alert} onChange={(event) => dispatch(privateDBCreate({ reported_early_waring_alert: event.target.checked }))} />
                        </FieldLayout>


                        <Divider sx={{ marginY: "10px" }} />

                        <FieldLayout {...{ title: 'Status' }}>
                            <Switch checked={privateDB?.status} onChange={(event) => onStatusChange(event)} />
                        </FieldLayout>

                    </Container>






                    <CardActions sx={{ padding: "15px" }}>
                        <Button
                            disabled={disableButton}
                            variant="contained"
                            color='primary'
                            type="submit"
                            onClick={() => onSave()}
                        >
                            Submit
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                        <Typography sx={{ flexGrow: 1 }} />
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleDelete()}
                            color={'warning'}
                        >
                            delete
                        </Button>
                    </CardActions>
                </Card>
            </Container>
        </React.Fragment>
    )


}

export default PrivateDBEdit;